export default __webpack_public_path__ + "static/media/2x-app-store.d62db311.svg";